import { render, staticRenderFns } from "./tag-label.vue?vue&type=template&id=60d8ed08&scoped=true&"
import script from "./tag-label.vue?vue&type=script&lang=js&"
export * from "./tag-label.vue?vue&type=script&lang=js&"
import style0 from "./tag-label.vue?vue&type=style&index=0&id=60d8ed08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d8ed08",
  null
  
)

export default component.exports